import { Build, ContactSupport, Warning } from '@mui/icons-material';

enum NotificationType {
  INFO = 'info',
  MAINTENANCE = 'maintenance',
  INCIDENT = 'incident'
}

export interface SystemNotificationType {
  label: string;
  value: string;
  icon: JSX.Element;
}

export const types: SystemNotificationType[] = [
  { label: 'Info', value: 'info', icon: <ContactSupport /> },
  { label: 'Maintenance', value: 'maintenance', icon: <Build /> },
  { label: 'Incident', value: 'incident', icon: <Warning /> }
];

export interface SystemNotification {
  id: number;
  headline: string;
  content: string;
  createdAt: Date;
  startDate: Date;
  endDate?: Date;
  isActive: boolean;
  type: NotificationType;
}
